module.exports = {
      id: "icon-copy-usage",
      viewBox: "0 0 19.657 19.657",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-copy",
      toString: function () {
        return this.url;
      }
    }